module.exports = __webpack_public_path__ + "static/media/mu.c46e5e20.svg";